module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"removeConfirm":"Are you sure want to delete this interest?"},"et":{"removeConfirm":"Are you sure want to delete this interest?"},"ru":{"removeConfirm":"Are you sure want to delete this interest?"}}')
  delete Component.options._Ctor
}
